import { defineComponent as _defineComponent } from 'vue';
import EnIcon from 'Components/icons/EnIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnBreadcrumbItem',
    props: {
        breadcrumb: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        function isExternalUrl(url) {
            return url?.includes?.('http');
        }
        const __returned__ = { props, isExternalUrl, EnIcon };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
